import React from 'react';
import NotFound from '../not-found';

function NotFoundPage() {
    return (
        <NotFound />
    )
}

export default NotFoundPage;